<template>
  <footer id="foot">
    <div id="bot0124">
      <div class="botNav">
        <a href="https://www.myfund.com/mutualFund.html" target="_blank">公募基金</a><span class="ssu"></span>
        <a href="https://www.myfund.com/youxuan50.html" target="_blank">优选50</a><span class="ssu"></span>
        <a href="https://www.myfund.com/pubScreen.html" target="_blank">公募筛选</a><span class="ssu"></span>
        <a href="https://www.myfund.com/fundrank.html" target="_blank">基金排名</a><span class="ssu"></span>
        <a href="https://www.myfund.com/NewdiagnosisOfEntrance.html" target="_blank">基金诊断</a><span class="ssu"></span>
        <a href="https://www.myfund.com/AutomaticInvestment.html" target="_blank">基金定投</a><span class="ssu"></span>
        <a href="https://www.myfund.com/privateChannelNew.html" target="_blank">私募基金</a><span class="ssu"></span>
        <a href="https://www.myfund.com/ruiSelected.html" target="_blank">睿选100</a><span class="ssu"></span>
        <a href="https://www.myfund.com/screenone.html?type=product" target="_blank">私募筛选</a><span class="ssu"></span>
        <a href="https://www.myfund.com/channels/16.html" target="_blank">展恒视角</a><span class="ssu"></span>
        <a href="https://www.myfund.com/channels/17.html" target="_blank">公募研报</a><span class="ssu"></span>
        <a href="https://www.myfund.com/channels/18.html" target="_blank">私募研报</a><span class="ssu"></span>
        <a href="https://www.myfund.com/channels/59.html" target="_blank">基金直播间</a>
      </div>
      <div class="botCon">
        <div class="top">
          <div class="con1">
            <div>展恒基金（总部）地址：北京朝阳区北四环中路27号院5号楼A座6层11室</div>
            <div>客服热线：400-818-8000</div>
            <div>客服邮箱：CALLCENTER@myfp.cn</div>
            <div>Copyright©2004-2021 北京展恒基金销售股份有限公司版权所有</div>
          </div>
          <ul class="con2">
            <li>
              <img src="https://www.myfund.com/images/weixin-gongzhonghao.jpg" alt="" class="codeIg">
              <span>展恒基金</span>
              <span>微信公众号</span>
            </li>
            <li>
              <img src="https://www.myfund.com/images/gongmu-wxkefu.jpg" alt="" class="codeIg">
              <span>公募基金</span>
              <span>微信客服号</span>
            </li>
            <li>
              <img src="https://www.myfund.com/images/simu-wxkefu.jpg" alt="" class="codeIg">
              <span>私募基金</span>
              <span>微信客服号</span>
            </li>
            <li>
              <img src="https://www.myfund.com/images/APP-download.jpg" alt="" class="codeIg">
              <span>展恒基金</span>
              <span>APP下载</span>
            </li>
          </ul>
        </div>
        <div class="con3">风险提示：展恒基金网所提供基金产品均由第三方机构管理，展恒基金不对基金产品业绩做任何保证，
          投资者应仔细阅读基金产品的法律文件，了解产品风险和收益特征（包括系统性风险和特定产品所特有的投资风险等），根据自身资产状况、风险承受能力选择适合自己的基金产品。展恒基金网刊载的所有信息（包括基金产品宣传推介材料）仅供投资者参考，不构成展恒基金网的任何推荐和投资建议。基金过往业绩不代表未来业绩的预示或预测，投资者应独立审慎决策、独立承担风险。
        </div>
      </div>
    </div>
  </footer>

</template>

<script>
export default {
  name: "lv-footer",
  data () {
    return {
    }
  },
}
</script>

